export enum EmployerTypes {
  TRANSPORT_COMPANY = 'TRANSPORT_COMPANY',
  WORKSHOP = 'WORKSHOP',
  CONTROL_AUTHORITY = 'CONTROL_AUTHORITY'
}
